import React from 'react';

export default function HorizontalLine ({ additionalClasses }) {
  return <hr className={ additionalClasses }/>;
}